import type { GetSandboxServerLogsResponseBody } from "@imagine/ai-service/shared-types/route-types";
import { aiServiceFetch } from "./ai-service-client";
import { HttpError } from "./http-error";

export const getSandboxServerLogs = async ({
  projectId,
}: {
  projectId: string;
}): Promise<GetSandboxServerLogsResponseBody> => {
  const response = await aiServiceFetch(
    `/api/projects/${projectId}/server-logs`,
    {
      method: "GET",
    },
  );

  if (!response.ok) {
    throw await HttpError.fromResponse(response);
  }

  return response.json();
};
